import { useDraggable, DragOverlay } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { observer } from "mobx-react-lite";
import s from "./DraggableItem.module.scss";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  children: React.ReactNode;
}

export const DraggableItem = observer((props: Props) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: props.id,
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} {...props}>
      {props.children}
    </div>
  );
});
